import { useMediaQuery } from '@mui/material';
import { FC } from 'react';
import { Icons, Typography } from '../../../stories/atoms';
import { ColumnFlexContainer, RowFlexContainer } from '../../../stories/atoms/containerV2/ContainerV2';
import { Button } from '../../../stories/molecules';
import { Colors, muiTheme } from '../../../theme';
import { commonTranslations } from '../../../translations';
import { StyledIcon } from '../YearlyStockTakePage.styles';

type StateViewProps = {
  color: Colors;
  icon: Icons;
  title: string;
  subTitle: string;
  stockItems: JSX.Element;
  onClose: () => void;
};

export const StateView: FC<StateViewProps> = ({ icon, title, subTitle, color, stockItems, onClose }) => {
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('tabletPortrait'));

  const { close } = commonTranslations;

  return (
    <ColumnFlexContainer padding={isMobile ? [10, 0] : [0]} data-testid="state-view-wrapper">
      <ColumnFlexContainer width="100%" alignItems="center" margin={[0, 0, 4]}>
        <StyledIcon icon={icon} color={color} sizeSpacing={[15]} />
      </ColumnFlexContainer>
      <Typography type="h4" textAlign="center">
        {title}
      </Typography>
      <Typography type="body2" textAlign="center" margin={[0, 0, 4]}>
        {subTitle}
      </Typography>
      {stockItems}
      <RowFlexContainer flex={1} padding={[3, 0, 0]}>
        <Button fullWidth label={(close.key, close.defaultValue)} onClick={onClose} />
      </RowFlexContainer>
    </ColumnFlexContainer>
  );
};
